module.exports = __webpack_public_path__ + "images/category_lp/common/reason3-man-30_b2ca96cc0b24f50550341b592fead7e1.jpg";